// extracted by mini-css-extract-plugin
export default {"root":"lqaZqmxuf7afB5JPMxu7","after-photos-disabled-photos":"MqoQBgxYFzwu2Yv3kjFt"};